import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { delay, keys, debounce } from 'lodash';
import { AgGridReact } from 'ag-grid-react';
import { Button } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import ProgressBar from '../../../../components/progress-bar';
import styles from './styles.css';
import CustomHeader from '../../../../components/god-table/header';
import ContactDetailRenderer from './cells/ContactDetailRenderer';
import ContactEmailRenderer from './cells/ContactEmailRenderer';
import SurveyStatusRenderer from './cells/SurveyStatusRenderer';
import SurveyEmailRenderer from './cells/SurveyEmailRenderer';
import CancelOutreactRenderer from './cells/CancelOutreactRenderer';
import SurveyOutreachAteemptRenderer from './cells/SurveyOutreachAttemptRenderer';
import CancelOutreactForm from '../../../Feedback/components/opportunity-box/CancelOutReachForm';

import {
  fetchWinLossOpportunitySurveys,
  winLossCancelSurveys,
} from '../../DashboardActions';
import { getWinLossOpportunitySurveys } from '../../DashboardReducer';

const MAIN_HEIGHT_COMPACT = 70;

function SurveyCollectorRenderer(props) {
  const text = props.value;
  return (
    <strong>{text}</strong>
  );
}

function StatusPanel(props) {
  return (
    <div style={{ paddingTop: 5, paddingBottom: 5 }}>
      <Button bsSize="xs" bsStyle="primary" onClick={props.requestAddOpportunitySurvey}>
        <Fa name="plus" /> Request Feedback
      </Button>
    </div>
  );
}


class SurveyManagerRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      cancelContact: null,
    };
    this.onGridReady = this.onGridReady.bind(this);
    this.requestAddOpportunitySurvey = this.requestAddOpportunitySurvey.bind(this);
    this.handleRequestCancel = this.handleRequestCancel.bind(this);
    this.handleGroupExpandedOrCollapsed = this.handleGroupExpandedOrCollapsed.bind(this);
    
    this.resetRowHeights = debounce(this.resetRowHeights.bind(this), 300);
    this.showLoadingOverlay = this.showLoadingOverlay.bind(this);
    this.hideLoadingOverlay = this.hideLoadingOverlay.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleCancelOutreach = this.handleCancelOutreach.bind(this);
  }

  componentWillMount() {
    const { data, surveys } = this.props;
    if (!surveys) {
      this.showLoadingOverlay();
      this.setState({ loading: true });
      if (this.props.node) {
        this.props.node.setRowHeight(MAIN_HEIGHT_COMPACT);
      }
      this.props.dispatch(fetchWinLossOpportunitySurveys(data.opportunity_id))
        .then(() => {
          this.setState({ loading: false }, () => {
            this.hideLoadingOverlay();
            this.refreshTable();
          });
        });
    } else {
      this.setState({ loading: false }, () => {
        this.refreshTable();
      });
    }
  }

  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    if (this.props.api) {
      const detailGridId = this.createDetailGridId();
      // ag-Grid is automatically destroyed
      this.props.api.removeDetailGridInfo(detailGridId);
    }
    this.mounted = false;
  }

  refreshTable() {
    if (this.props.api) {
      this.props.api.refreshCells();
    }
  }
  showLoadingOverlay() {
    if (this.props.api) {
      this.props.api.showLoadingOverlay();
    }
  }
  hideLoadingOverlay() {
    if (this.props.api) {
      this.props.api.hideOverlay();
    }
  }

  handleModalClose() {
    this.setState({ cancelContact: null, showCancelModal: false });
  }
  handleCancelOutreach(contact, reason) {
    const { data } = this.props;
    const contactId = contact.id;
    const collectorId = contact.collector_id;
    const opportunityId = data.opportunity_id;
    return this.props.dispatch(winLossCancelSurveys(collectorId, opportunityId, contactId, false, reason));
  }

  resetRowHeights() {
    if (this.gridApi) {
      this.gridApi.resetRowHeights();
      if (this.el) {
        if (this.props.node) {
          this.props.node.setRowHeight(this.el.clientHeight);
      
        }
        if (this.props.api) {
          this.props.api.resetRowHeights();
        }
      }
    }
  }

  handleGroupExpandedOrCollapsed() {
    this.resetRowHeights();
  }

  onGridReady(params) {
    const detailGridId = this.createDetailGridId();
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.props.api) {
      const gridInfo = {
        id: detailGridId,
        api: this.gridApi,
        columnApi: this.gridColumnApi,
      };
      this.props.api.addDetailGridInfo(detailGridId, gridInfo);
    }
    this.resetRowHeights();
  }
  requestAddOpportunitySurvey(e) {
    e.preventDefault();
    const { data } = this.props;
    this.props.requestAddOpportunitySurvey(data);
  }

  handleRequestCancel(contact) {
    this.setState({ cancelContact: contact, showCancelModal: true });
    /*
    const { data } = this.props;
    return new Promise((resolve, reject) => {
      const contactId = contact.id;
      const collectorId = contact.collector_id;
      const opportunityId = data.opportunity_id;
      this.props.dispatch(winLossCancelSurveys(collectorId, opportunityId, contactId))
        .then(
          (results) => {
            resolve(results);
          },
          (errors) => {
            reject(errors);
          },
        );
    });
    */
  }
  checkHeight(props) {
    delay(() => {
      if (props.surveys && this.mounted) {
        const height = this.getHeight(props.surveys);
        if (this.props.node) {
          this.props.node.setRowHeight(height);
        }
        if (this.props.api) {
          this.props.api.onRowHeightChanged();
        }
      }
    }, 500);
  }

  createDetailGridId() {
    return `detail_${this.props.data.opportunity_id}`;
  }

  renderGrid() {
    const { surveys } = this.props;
    const columnDefs = [
      {
        headerName: 'Contact',
        suppressMenu: true,
        valueGetter: 'data.first_name + " " + data.last_name',
        width: 204,
        cellRenderer: 'contactDetailRenderer',
        cellRendererParams: {
          idField: 'contact_id',
        },
      },
      {
        headerName: 'Title',
        suppressMenu: true,
        field: 'title',
        hide: true,
      },
      {
        headerName: 'Email',
        suppressMenu: true,
        field: 'email',
        width: 200,
        cellRenderer: 'contactEmailRenderer',
      },
      {
        headerName: 'Phone',
        suppressMenu: true,
        field: 'phone',
        hide: true,
      },
      {
        headerName: 'Mobile',
        suppressMenu: true,
        field: 'mobile_phone',
        hide: true,
      },
      {
        headerName: 'Last Status',
        suppressMenu: true,
        field: 'last_status',
        width: 100,
        cellRenderer: 'surveyStatusRenderer',
      },
      {
        headerName: 'Last Email',
        suppressMenu: true,
        field: 'last_email_date',
        width: 160,
        cellRenderer: 'surveyEmailRenderer',
        cellRendererParams: {
          requestShowEmail: this.props.requestShowEmail,
          object: this.props.data,
          isNext: false,
        },
      },
      {
        headerName: 'Next Email',
        suppressMenu: true,
        field: 'next_email_date',
        width: 160,
        cellRenderer: 'surveyEmailRenderer',
        cellRendererParams: {
          requestShowEmail: this.props.requestShowEmail,
          object: this.props.data,
          isNext: true,
        },
      },
      {
        headerName: 'Outreach Attempts',
        suppressMenu: true,
        field: 'completed_attempts',
        width: 150,
        cellRenderer: 'outreachAteemptRenderer',
      },
      {
        headerName: 'Outreach',
        suppressMenu: true,
        width: 120,
        suppressMovable: true,
        suppressResize: true,
        pinned: 'right',
        cellRenderer: 'cancelOutreactRenderer',
        field: 'contact_status',
        cellRendererParams: {
          requestCancel: this.handleRequestCancel,
        },
      },
      {
        field: 'collector_name',
        headerName: 'Collector',
        suppressMenu: true,
        rowGroup: true,
        hide: true,
      },
    ];
    return (
      <div className={`${styles.contactTable} ag-theme-alpine`} style={{ width: '100%' }} >
        <AgGridReact
          reactNext
          id={this.createDetailGridId()}
          enableColResize
          enableSorting
          getRowNodeId={o => o.contact_id}
          columnDefs={columnDefs}
          rowData={surveys}
          onGridReady={this.onGridReady}
          groupDefaultExpanded={-1}
          groupUseEntireRow
          animateRows
          groupRowInnerRenderer="groupRowInnerRenderer"
          domLayout="autoHeight"
          statusBar={this.props.api ? {
            statusPanels: [
              { 
                statusPanel: 'statusPanel', 
                align: 'left',
                statusPanelParams: {
                  requestAddOpportunitySurvey: this.requestAddOpportunitySurvey,
                },
              },
            ],
          } : null}
          onRowGroupOpened={this.handleGroupExpandedOrCollapsed}
          components={{
            agColumnHeader: CustomHeader,
            contactDetailRenderer: ContactDetailRenderer,
            contactEmailRenderer: ContactEmailRenderer,
            surveyStatusRenderer: SurveyStatusRenderer,
            surveyEmailRenderer: SurveyEmailRenderer,
            cancelOutreactRenderer: CancelOutreactRenderer,
            outreachAteemptRenderer: SurveyOutreachAteemptRenderer,
            groupRowInnerRenderer: SurveyCollectorRenderer,
            statusPanel: StatusPanel,
          }}
        />
      </div>
    );
  }

  renderEmpty() {
    const cls = this.props.api ? styles.contactWrapper : null;
    return (
      <div ref={(el) => { this.el = el; }} className={cls}>
        No surveys found.
      </div>
    );
  }

  render() {
    const { loading, cancelContact, showCancelModal } = this.state;
    const cls = this.props.api ? styles.contactWrapper : null;
    if (loading) {
      return (<div className={cls}><ProgressBar /></div>);
    }
    const { surveys } = this.props;
    if (!surveys || surveys.length === 0) {
      return this.renderEmpty();
    }
    return (
      <div ref={(el) => { this.el = el; }} className={cls}>
        {this.renderGrid()}
        {cancelContact !== null &&
          <CancelOutreactForm
            show={showCancelModal}
            contact={cancelContact}
            onClose={this.handleModalClose}
            onRequestCancel={this.handleCancelOutreach}
          />
        }
      </div>
    );
  }
}

SurveyManagerRenderer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.shape({
    opportunity_id: PropTypes.string,
  }).isRequired,
  api: PropTypes.shape({
    addDetailGridInfo: PropTypes.func.isRequired,
    removeDetailGridInfo: PropTypes.func.isRequired,
    onRowHeightChanged: PropTypes.func.isRequired,
  }),
  node: PropTypes.shape({
    setRowHeight: PropTypes.func.isRequired,
  }),
  surveys: PropTypes.arrayOf(PropTypes.shape({})),
  requestAddOpportunitySurvey: PropTypes.func,
  requestShowEmail: PropTypes.func,
};
SurveyManagerRenderer.defaultProps = {
  surveys: null,
  api: null,
  node: null,
  requestAddOpportunitySurvey: () => {},
  requestShowEmail: () => {},
};
function mapStateToProps(state, ownProps) {
  const surveys = getWinLossOpportunitySurveys(state, ownProps.data.opportunity_id);

  return {
    surveys,
  };
}

export default connect(mapStateToProps)(SurveyManagerRenderer);
